import { RoleDetailsTable } from "~/pages/UserAndRoles/CanopyRolesPage/CanopyRoleDetails/components/RoleDetailsTable";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { useAgGridUtils } from "~/pages/UserAndRoles/utils/gridUtils";
import { useFetchAssignedUsersByRoleName, useWpAssignedUsersTableAgGridOptions } from "./hooks";

type AssignedUsersTabProps = {
  roleName?: string;
};

export const AssignedUsersTab = ({ roleName }: AssignedUsersTabProps) => {
  const { columnDefs } = useWpAssignedUsersTableAgGridOptions();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
      overlayNoRowsTemplate: "No users found",
    },
  });
  const { rowData, useArenaAccessByUsersQueryResult } =
    useFetchAssignedUsersByRoleName(roleName);
  const {
    onGridReady: onUsersGridReady,
    resetFilters: resetUsersFilters,
    isFilterPresent,
    onFilterChanged,
  } = useAgGridUtils();

  return (
    <RoleDetailsTable
      queryResult={useArenaAccessByUsersQueryResult}
      title="Assigned users"
      columnDefs={columnDefs}
      rowData={rowData}
      gridOptions={gridOptions}
      onGridReady={onUsersGridReady}
      resetFilters={resetUsersFilters}
      isFilterPresent={isFilterPresent}
      onFilterChanged={onFilterChanged}
    />
  );
};
